import { atom } from 'jotai';
import { atomWithCookie } from './atomWithCookie';

/**
 * Panel open/close state — persisted in cookie so the panel
 * remembers its state across page reloads and sessions.
 */
export const agentPanelOpenAtom = atomWithCookie<boolean>('agentPanelOpen', false);

/**
 * Context about the page the user is currently viewing.
 * Written by AgentChatPanel on every navigation change,
 * read by useAgentStream when sending messages so the
 * agent knows where the user is working.
 */
export type PageContext = {
  // IDs
  organizationId?: string;
  workspaceId?: string;
  // Human-readable names (so the agent can address the user naturally)
  organizationName?: string;
  workspaceName?: string;
  // Navigation context
  path?: string;
  /** Current sidebar section: 'datasets', 'channels', 'services', etc. */
  section?: string;
  /** Entity ID from the URL path (e.g. datasetId, channelId, serviceId) */
  entityId?: string;
  /** Entity type matching the section (e.g. 'dataset', 'channel', 'service') */
  entityType?: string;
};

/**
 * Current page context atom — written by AgentChatPanel's useEffect,
 * read by useAgentStream when sending messages.
 */
export const agentPageContextAtom = atom<PageContext>({});
